import { createAsyncThunk } from "@reduxjs/toolkit";
import { ApiRequest, serializeModel } from "../../../api";
import { SiteRequest } from "../../../site";

export const fetchCategories = createAsyncThunk(
  "categories/fetch",
  async ({ api, value }: ApiRequest<SiteRequest>) => {
    const { companyId, siteId } = value;
    const response = await api.getSiteCategoryTree(companyId, siteId);

    return serializeModel(response.value);
  },
);
